module.exports = __webpack_public_path__ + "img/logoJava.1df038d8.svg";